// utils/logger.ts

interface LogContext {
  [key: string]: unknown; // Allows any key-value pairs
}

interface ErrorLog {
  error: Error;
  context?: LogContext;
  environment: "development" | "production" | "test";
  timestamp: string;
}

// Type guard for Error objects
function isError(error: unknown): error is Error {
  return error instanceof Error;
}

// Convert unknown error types to Error instance
function toError(error: unknown): Error {
  if (isError(error)) return error;
  return new Error(typeof error === "string" ? error : JSON.stringify(error));
}

export function logError(rawError: unknown, context?: LogContext): void {
  const error = toError(rawError);
  const logEntry: ErrorLog = {
    error: {
      name: error.name,
      message: error.message,
      stack: error.stack,
    },
    context,
    environment: process.env.NODE_ENV as ErrorLog["environment"],
    timestamp: new Date().toISOString(),
  };

  // Development: Log to console with full details
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.error(error.message, logEntry);
  }

  // Production: Send to logging endpoint (silent fail)
  if (process.env.NODE_ENV === "production") {
    // TODO: after we have logging system, send the logEntry to the service
    // eslint-disable-next-line no-console
    console.warn(rawError);
  }
}
